// Navigation mega menu JS #Krunal's-Script
const navItems = document.querySelectorAll('.navbar_nav .nav-item');
if (navItems) {
  navItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      navItems.forEach(el => el.classList.remove('active'));

      item.classList.add('active');
    });

    item.addEventListener('mouseleave', () => {
      item.classList.remove('active');
    });
  });
}

let newArrivalSlider = new Swiper(".new_arrival_slider", {
  slidesPerView: 1.1,
  spaceBetween: 8,
  centeredSlides: true,
  loop: true,
  initialSlide: 1,
  mousewheel: {
    forceToAxis: true, // Only respond to horizontal scroll
    releaseOnEdges: true,
    sensitivity: 0.5,
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  slideToClickedSlide: true,
  navigation: {
    nextEl: ".new_arrival_slider .swiper-button-next",
    prevEl: ".new_arrival_slider .swiper-button-prev",
  },
  breakpoints: {
    576: { slidesPerView: 1.2, spaceBetween: 12 },
    768: { slidesPerView: 1.8, spaceBetween: 12 },
    992: { slidesPerView: 1.8, spaceBetween: 12 },
    1200: { slidesPerView: 1.9, spaceBetween: 12, simulateTouch: false, allowTouchMove: false, grabCursor: false },
    1800: { slidesPerView: 1.6, spaceBetween: 12, simulateTouch: false, allowTouchMove: false },
  },
});


document.querySelectorAll(".best_sellers_slider").forEach((slider) => {
  const section = slider.closest(".best_sellers");

  new Swiper(slider, {
    slidesPerView: "auto",
    spaceBetween: 11,
    freeMode: false,
    cssMode: false,
    centeredSlides: true,
    loop: true,

    scrollbar: {
      el: section.querySelector(".swiper-scrollbar"),
      dragSize: "auto",
      draggable: true,
    },

    navigation: {
      nextEl: section.querySelector(".swiper-button-next"),
      prevEl: section.querySelector(".swiper-button-prev"),
    },

    pagination: {
      el: section.querySelector(".swiper-pagination"),
      clickable: true,
      dynamicBullets: true,
    },

    breakpoints: {
      0: {
        centeredSlides: true,
        loop: true,
      },

      576: {
        spaceBetween: 16,
      },

      768: {
        spaceBetween: 16,
      },

      992: {
        spaceBetween: 16,
        simulateTouch: false,
        allowTouchMove: false,
        grabCursor: false,
        centeredSlides: false,
        loop: false,
      },

      1440: {
        spaceBetween: 16,
        simulateTouch: false,
        allowTouchMove: false,
      },
    },
  });
});


var swiper = new Swiper(".oc_slider", {
  slidesPerView: 1.1,
  spaceBetween: 10,
  speed: 800,
  loop: true,
  direction: "horizontal",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".oc_slider .swiper-button-next",
    prevEl: ".oc_slider .swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true, // Ensures it only moves when the slider is in view
  },
  touchRatio: 2, // Increase touch sensitivity
  simulateTouch: true, // Allow simulated touch events
  grabCursor: true, // Show hand cursor when hovering
  mousewheel: {
    enabled: true,
    forceToAxis: true, // Scroll only in Swiper's direction
    sensitivity: 2, // Increase sensitivity
    releaseOnEdges: true, // Allow natural scroll stopping
  },

  breakpoints: {
    0: {
      autoHeight: true,
    },
    576: {
      slidesPerView: 1.1,
      spaceBetween: 15,
    },
    768: {
      autoHeight: false,
    },
    992: {
      slidesPerView: 1.05,
      spaceBetween: 15,
    },
    1200: {
      slidesPerView: 1.03,
      spaceBetween: 15,
    },
    1600: {
      slidesPerView: 1.06,
      spaceBetween: 15,
    },
    1800: {
      slidesPerView: 1.01,
      spaceBetween: 15,
    },
  },
});
/*
  Product recommendations slider init.

  Previously this used a one-shot setInterval that initialized Swiper the
  *first* time `.product_recommendation_slider` appeared in the DOM, then
  stopped checking forever (clearInterval). Because <product-recommendations>
  loads/replaces its content asynchronously, that first check could either
  fire too early (before the real slides exist) or get its DOM swapped out
  from under it afterward - leaving raw, un-initialized swiper-slide markup
  (stacked, full width, oversized image) with nothing left to fix it. A hard
  refresh just happened to change the timing enough to "accidentally" work.

  This version uses a MutationObserver scoped to each <product-recommendations>
  element's direct children, so Swiper is (re)initialized every time this
  element's content is first rendered OR later replaced - reliably, on every
  load, for every product, with no dependency on timing.
*/
function initProductRecommendationSlider(root) {
  var sliderEl = root.querySelector('.product_recommendation_slider');
  if (!sliderEl) return;
  if (!sliderEl.querySelectorAll('.swiper-slide').length) return;

  // If a previous instance is already attached to this exact node
  // (e.g. from an earlier init pass), tear it down first so we never
  // end up with duplicate/stale Swiper instances on the same element.
  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  new Swiper(sliderEl, {
    slidesPerView: 1.3,
    spaceBetween: 10,
    initialSlide: 0,
    mousewheel: {
      forceToAxis: true, // Only respond to horizontal scroll
      releaseOnEdges: true,
      sensitivity: 0.5,
    },
    pagination: {
      el: sliderEl.querySelector('.swiper-pagination'),
      clickable: true,
    },
    scrollbar: {
      el: sliderEl.querySelector('.swiper-scrollbar'),
      draggable: true,
    },
    navigation: {
      nextEl: sliderEl.querySelector('.swiper-button-next'),
      prevEl: sliderEl.querySelector('.swiper-button-prev'),
    },
    slideToClickedSlide: true,
    breakpoints: {
      450: {
        slidesPerView: 2.3,
        spaceBetween: 10,
      },
      576: {
        slidesPerView: 2.5,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 15,
        simulateTouch: false, allowTouchMove: false, grabCursor: false
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 15,
        simulateTouch: false, allowTouchMove: false
      },
      1400: {
        slidesPerView: 4,
        spaceBetween: 27,
        simulateTouch: false, allowTouchMove: false
      },
    },
  });
}

document.querySelectorAll('product-recommendations').forEach(function (root) {
  // Covers the common case: the slider content is already present on
  // first paint (server-rendered), so it works immediately - no reload
  // needed.
  initProductRecommendationSlider(root);

  // Covers the case where this element's content is fetched/replaced
  // asynchronously after first paint. Re-init whenever the new markup
  // lands, instead of giving up after a single check like before.
  // Scoped to direct children only (not subtree) so Swiper's own
  // internal DOM updates (pagination bullets, slide classes, etc.)
  // never re-trigger this observer.
  var pendingInit = false;
  var observer = new MutationObserver(function () {
    if (pendingInit) return;
    pendingInit = true;
    requestAnimationFrame(function () {
      pendingInit = false;
      initProductRecommendationSlider(root);
    });
  });
  observer.observe(root, { childList: true });
});

var commonSlider = new Swiper(".common_product_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".common_product_slider .swiper-button-next",
    prevEl: ".common_product_slider .swiper-button-prev",
  },
  pagination: {
    el: ".common_product_slider .swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 15,
      simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 15,
      simulateTouch: false, allowTouchMove: false,
    },
    1400: {
      slidesPerView: 4,
      spaceBetween: 26,
      simulateTouch: false, allowTouchMove: false,
    },
  },
})

// Initialize Swiper
var cp_slider = new Swiper(".cp_slider", {
  spaceBetween: 20,
  speed: 1000,
  delay: 300,
  pagination: {
    el: ".swiper-pagination",
    clickable: true, // Ensure bullets are clickable
    dynamicBullets: true, // Set default to false; will update dynamically
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  touchRatio: 2,
  simulateTouch: true,
  grabCursor: true,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
    sensitivity: 2,
    releaseOnEdges: true,
  },
  breakpoints: {
    0: {
      autoHeight: true,
    },
    768: {
      autoHeight: false,
    },
  },
});



document.querySelectorAll(".odd_even_slider").forEach(function (sliderEl) {
  if (sliderEl.swiper) return;

  var isReversed = sliderEl.classList.contains("odd_even_slider_rev");

  function fixPagination(swiper) {
    // Remove phantom snap point that creates an extra bullet
    if (swiper.snapGrid.length > swiper.slidesGrid.length) {
      swiper.snapGrid = swiper.snapGrid.slice(0, swiper.slidesGrid.length);
    }

    swiper.pagination.render();
    swiper.pagination.update();
    swiper.updateSlidesClasses();
  }

  new Swiper(sliderEl, {
    slidesPerView: "auto",
    direction: "horizontal",
    centeredSlides: false,
    spaceBetween: 12,
    speed: 1000,
    roundLengths: true,

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    pagination: {
      el: sliderEl.querySelector(".swiper-pagination"),
      clickable: true,
    },

    navigation: {
      nextEl: sliderEl.querySelector(".swiper-button-next"),
      prevEl: sliderEl.querySelector(".swiper-button-prev"),
    },

    touchRatio: 2,
    simulateTouch: true,
    grabCursor: true,
    allowTouchMove: true,

    mousewheel: {
      enabled: true,
      forceToAxis: true,
      sensitivity: 2,
      releaseOnEdges: true,
    },

    breakpoints: {
      0: {
        autoHeight: true,
        spaceBetween: 0,
        allowTouchMove: true,
      },
      768: {
        autoHeight: false,
        spaceBetween: 12,
        allowTouchMove: true,
      },
      992: {
        autoHeight: false,
        spaceBetween: 12,
        rtl: isReversed, // Keep only if your current setup requires it
        allowTouchMove: true,
      },
    },

    on: {
      init: function () {
        fixPagination(this);
      },

      resize: function () {
        this.update();
        fixPagination(this);
      },

      breakpoint: function () {
        this.update();
        fixPagination(this);
      },

      update: function () {
        fixPagination(this);
      },

      slideChange: function () {
        this.pagination.update();
      },
    },
  });
});




// ====================================
let mediaWidthMaxGe = window.matchMedia("(min-width: 576px)");

if (mediaWidthMaxGe.matches) {
  setTimeout(() => {
    var geSlider = new Swiper(".grp-entangle-swiper-container", {
      slidesPerView: 1.2,
      spaceBetween: 10,
      centeredSlides: true,
      speed: 1000,
      loop: true,
      // autoplay: true,
      breakpoints: {
        576: {
          slidesPerView: 1.6,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 2.2,
          spaceBetween: 40,
        },
        1600: {
          slidesPerView: 2.5,
          spaceBetween: 80,
        },
        1950: {
          slidesPerView: 4,
          spaceBetween: 80,
        },
      },
    });
  }, 1000);
}

var projectSlider = new Swiper(".project_slider", {
  slidesPerView: 1,
  spaceBetween: 12,
  freeMode: false,
  cssMode: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".project_slider .swiper-button-next",
    prevEl: ".project_slider .swiper-button-prev",
  },
  pagination: {
    el: ".project_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,

    },
    992: {
      slidesPerView: 3,
      spaceBetween: 16,
      simulateTouch: false, allowTouchMove: false,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24,
      simulateTouch: false, allowTouchMove: false,
    },
  },
});

var mcsSlider = new Swiper(".mcs_slider", {
  slidesPerView: 1,
  spaceBetween: 14,
  autoHeight: true,
  navigation: {
    nextEl: ".mcs_slider .swiper-button-next",
    prevEl: ".mcs_slider .swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  pagination: {
    el: ".mcs_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    992: {
      simulateTouch: false, allowTouchMove: false,
      autoHeight: false, grabCursor: false,
    },
  },
});
var plProductsSlider = new Swiper(".pl_products_slider", {
  slidesPerView: 1,
  spaceBetween: 12,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".pl_products_slider .swiper-button-next",
    prevEl: ".pl_products_slider .swiper-button-prev",
  },
  pagination: {
    el: ".pl_products_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 16,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 16,
      spaceBetween: 11, simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24, simulateTouch: false, allowTouchMove: false,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 26, simulateTouch: false, allowTouchMove: false,
    },
  },
});

var owSlider = new Swiper(".ow_slider", {
  slidesPerView: "auto",
  spaceBetween: 24,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  mousewheel: {
    forceToAxis: true, // Only respond to horizontal scroll
    releaseOnEdges: true,
    sensitivity: 0.5,
  },
  navigation: {
    nextEl: ".ow_slider .swiper-button-next",
    prevEl: ".ow_slider .swiper-button-prev",
  },
  pagination: {
    el: ".ow_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    0: {
      autoHeight: true
    },
    768: {
      autoHeight: false
    },
    992: { autoHeight: false, simulateTouch: false, allowTouchMove: false, grabCursor: false },
  },
});

var swiper = new Swiper(".commercial_slider", {
  slidesPerView: "auto",
  spaceBetween: 25,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".commercial_slider .swiper-button-next",
    prevEl: ".commercial_slider .swiper-button-prev",
  },
  pagination: {
    el: ".commercial_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    992: { simulateTouch: false, allowTouchMove: false, grabCursor: false },
  },
});

var featuredProjectSlider = new Swiper(".featured_project_slider", {
  spaceBetween: 0,
  // centeredSlides: true,
  // allowTouchMove: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".featured_project_slider .swiper-button-next",
    prevEl: ".featured_project_slider .swiper-button-prev",
  },
  pagination: {
    el: ".featured_project_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    0: {
      slidesPerView: 1.1,
    },
    768: {
      slidesPerView: 1.6,
    },
    992: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
    1200: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
  },
});
var featuredProjectSlider = new Swiper(".ia_featured_projects .featured_project_slider", {
  spaceBetween: 20,
  // centeredSlides: true,
  // allowTouchMove: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".ia_featured_projects .featured_project_slider .swiper-button-next",
    prevEl: ".ia_featured_projects .featured_project_slider .swiper-button-prev",
  },
  pagination: {
    el: ".ia_featured_projects .featured_project_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    0: {
      slidesPerView: 1.1,
    },
    768: {
      slidesPerView: 1.6,
    },
    992: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
    1200: {
      slidesPerView: 2.4,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
    },
  },
});

const mediaQuery = window.matchMedia('(max-width: 991px)')
// Check if the media query is true

var promotionSlider = new Swiper(".promotion_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 1000,
  delay: 300,
  loop: true,
  autoplay: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
  },
})

var cpcSlider = new Swiper(".cpc_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  speed: 1000,
  delay: 300,
  autoHeight: true,
  // loop: true,
  // autoplay: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  touchRatio: 2,
  simulateTouch: true,
  grabCursor: true,
  mousewheel: {
    enabled: true,
    forceToAxis: true,
    sensitivity: 2,
    releaseOnEdges: true,
  },
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: ".cpc_slider .swiper-button-next",
    prevEl: ".cpc_slider .swiper-button-prev",
  },
});
var cpiImageSlider = new Swiper(".cpi_image_slider", {
  slidesPerView: 1,
  spaceBetween: 15,
  autoHeight: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".cpi_image_slider .swiper-button-next",
    prevEl: ".cpi_image_slider .swiper-button-prev",
  },
  pagination: {
    el: ".cpi_image_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
  },
  breakpoints: {
    768: {
      slidesPerView: "auto",
      spaceBetween: 25,

    },
    992: {
      slidesPerView: "auto",
      spaceBetween: 25,
      simulateTouch: false, allowTouchMove: false, grabCursor: false,
      autoHeight: false,
    },

  },
});
var aps_slider = new Swiper(".aps_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".aps_slider .swiper-button-next",
    prevEl: ".aps_slider .swiper-button-prev",
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 26,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 26,
      simulateTouch: false,
      allowTouchMove: false,
      grabCursor: false
    },
  },
});
var gisSlider = new Swiper(".gis_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
    nextEl: ".gis_slider .swiper-button-next",
    prevEl: ".gis_slider .swiper-button-prev",
  },
  pagination: {
    el: ".gis_slider .swiper-pagination",
    clickable: true, // Ensure bullets are clickable
    dynamicBullets: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 24,
      simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 24,
      simulateTouch: false, allowTouchMove: false,
    },
  },
});

var popupSlider = new Swiper(".popup_product_slider", {
  slidesPerView: 1,
  spaceBetween: 12,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".popup_product_slider .swiper-button-next",
    prevEl: ".popup_product_slider .swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
      spaceBetween: 12,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
  },
});

var macProductSlider = new Swiper(".mac_product_slider", {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: ".mac_product_slider .swiper-pagination",
    clickable: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar",
    dragSize: "auto",
  },
  navigation: {
    nextEl: ".mac_product_slider .swiper-button-next",
    prevEl: ".mac_product_slider .swiper-button-prev",
  },
  breakpoints: {
    450: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
      simulateTouch: false, allowTouchMove: false, grabCursor: false
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 20,
      simulateTouch: false, allowTouchMove: false,
    },

  },
});

jQuery(document).ready(function () {


  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
      html: true,
      trigger: 'hover',
      delay: { show: 0, hide: 10 }
    });
  });

  // Add event listener to add/remove 'active' class
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    tooltipTriggerEl.addEventListener('shown.bs.tooltip', function () {
      // Add 'active' class when tooltip is shown
      tooltipTriggerEl.classList.add('active');
      // Add event listener to close tooltip on outside click
      document.addEventListener('click', closeTooltipOnOutsideClick);
    });

    tooltipTriggerEl.addEventListener('hidden.bs.tooltip', function () {
      // Remove 'active' class when tooltip is hidden
      tooltipTriggerEl.classList.remove('active');
      // Remove event listener when tooltip is hidden
      document.removeEventListener('click', closeTooltipOnOutsideClick);
    });
  });

  // Function to close tooltip on outside click
  function closeTooltipOnOutsideClick(event) {
    if (!tooltipTriggerList.some(el => el.contains(event.target))) {
      tooltipList.forEach(function (tooltip) {
        tooltip.hide();
      });
    }
  }
});

// Select all sliders and store their instances in an array
const slidersCollection = [];
/* Removed redundant initialization - now handled in facets.js for better sync 
document.querySelectorAll(".card_product_block_img_slider").forEach((slider, index) => {
  const nextClass = `card-slider-next-${index}`;
  const prevClass = `card-slider-prev-${index}`;
  const pageClass = `card-slider-page-${index}`;
  
  const nextEl = slider.querySelector('.card_product_block_img_slider_next');
  const prevEl = slider.querySelector('.card_product_block_img_slider_prev');
  const pageEl = slider.querySelector('.swiper-pagination');
  
  if (nextEl) nextEl.classList.add(nextClass);
  if (prevEl) prevEl.classList.add(prevClass);
  if (pageEl) pageEl.classList.add(pageClass);

  slidersCollection[index] = new Swiper(slider, {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: `.${nextClass}`,
      prevEl: `.${prevClass}`,
    },
    pagination: {
      el: `.${pageClass}`,
      clickable: true,
    }
  });
});
*/


// Exposed on window so product-storefront.js.liquid shares the exact same reference.
// (A top-level `let` is NOT on window, causing two separate Swiper instances on live.)
window.galleryThumbs = null;
window.galleryMain = null;

function initProductSlider() {
  // Destroy previous instances (always use window.* to target the shared reference)
  if (window.galleryThumbs) { window.galleryThumbs.destroy(true, true); window.galleryThumbs = null; }
  if (window.galleryMain) { window.galleryMain.destroy(true, true); window.galleryMain = null; }

  // THUMB SLIDER
  window.galleryThumbs = new Swiper(".thumb_product_slider", {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 10,
    direction: "horizontal",
    watchSlidesProgress: true,
    slideToClickedSlide: false,  // â† was true, caused jump on accidental thumb click
    watchOverflow: true,
    freeMode: false,
    loop: false,
    rewind: false,
    speed: 400,
    navigation: {
      nextEl: ".thumb-swiper-next",
      prevEl: ".thumb-swiper-prev",
      disabledClass: "swiper-button-disabled",
    },
    breakpoints: {
      576: { slidesPerView: 5, slidesPerGroup: 1, spaceBetween: 12 },
      768: { slidesPerView: 5, slidesPerGroup: 1, spaceBetween: 12 },
      992: { direction: "vertical", slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 15 },
    },
  });

  // MAIN SLIDER
  // loop: false â€” loop:true requires loopDestroy()+loopCreate() after every DOM injection;
  // skipping that caused activeIndex corruption after multiple finish changes.
  window.galleryMain = new Swiper(".main_product_slider", {
    spaceBetween: 20,
    loop: true,
    rewind: false,
    speed: 500,
    autoHeight: false,

    thumbs: {
      swiper: window.galleryThumbs,
    },

    breakpoints: {
      992: {
        direction: "vertical",
      },
    },
  });


}
// Init
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductSlider);
} else {
  initProductSlider();
}

// Guard: Shopify Section Rendering can re-inject this <script> tag.
if (!window.__pdpSliderListenerBound) {
  window.__pdpSliderListenerBound = true;
}



// == //

document.querySelectorAll('.catalogue_content_slider').forEach((container) => {
  const thumbSlider = container.querySelector('.cat_thumbSlider');
  const mainSlider = container.querySelector('.cat_mainSlider');

  if (thumbSlider && mainSlider) {
    const thumbsSwiper = new Swiper(thumbSlider, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: false,
      watchSlidesProgress: true,
      navigation: {
        nextEl: thumbSlider.querySelector('.swiper-button-next'),
        prevEl: thumbSlider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          spaceBetween: 18,
        },
      },
    });

    new Swiper(mainSlider, {
      loop: false,
      spaceBetween: 10,
      autoHeight: true,
      thumbs: {
        swiper: thumbsSwiper,
      },
    });
  }
});

document.querySelectorAll('.catalogue_content_slider').forEach((container) => {
  const thumbSliderSm = container.querySelector('.cat_thumbSlider_sm');
  const mainSliderSm = container.querySelector('.cat_mainSlider_sm');

  if (thumbSliderSm && mainSliderSm) {
    const thumbsSwipersm = new Swiper(thumbSliderSm, {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 'auto',
      freeMode: false,
      watchSlidesProgress: true,
      navigation: {
        nextEl: thumbSliderSm.querySelector('.swiper-button-next'),
        prevEl: thumbSliderSm.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        450: {
          spaceBetween: 15,
        },
        768: {
          spaceBetween: 15,
        },
        1200: {
          spaceBetween: 40,
        },
      },
    });

    new Swiper(mainSliderSm, {
      loop: false,
      spaceBetween: 10,
      autoHeight: true,
      thumbs: {
        swiper: thumbSliderSm,
      },
    });
  }
});

// Get main slider images
const mainSlides = document.querySelectorAll('.cat_mainSlider');

if (mainSlides) {
  // Dynamically create thumbnail slides using main slider images
  mainSlides.forEach((cat_mainSlider) => {
    cat_mainSlider.querySelectorAll('img').forEach((img) => {
      const slide = document.createElement('div');
      slide.classList.add('swiper-slide');
      const thumbImg = document.createElement('img');
      thumbImg.src = img.getAttribute("data-thumb");
      thumbImg.alt = img.alt;
      slide.appendChild(thumbImg);

      cat_mainSlider.nextElementSibling.querySelector('.swiper-wrapper').appendChild(slide);
    });
  });
}

// Header Searchbar
document.addEventListener('DOMContentLoaded', function () {
  const searchbarBtn = document.querySelector('.search_bar_icon');
  const menuOpening = document.querySelector('.menu-drawer-container');
  const headIcon = document.querySelector('summary.header__icon--menu');

  if (searchbarBtn && menuOpening && headIcon) {
    const parent = searchbarBtn.parentNode;

    searchbarBtn.addEventListener('click', function () {
      parent.classList.toggle('searchbar_active');

      if (parent.classList.contains('searchbar_active')) {
        // Close the menu if it's open
        menuOpening.classList.remove('menu-opening');
        menuOpening.removeAttribute('open');

        const attrs = {
          'aria-label': 'Menu',
          'aria-expanded': 'false',
          'role': 'button',
          'aria-controls': 'menu-drawer'
        };

        for (const [key, value] of Object.entries(attrs)) {
          headIcon.setAttribute(key, value);
        }
      }
    });

    // Close search bar when menu opens
    headIcon.addEventListener('click', function () {
      parent.classList.remove('searchbar_active');
    });
  }
});



jQuery(document).ready(function () {
  jQuery('.main_cart_conttainer , .cart_footer_container').wrapAll('<div class="custom_cart_wrapper"></div>');

  const cartFooter = document.querySelector('.main_cart_footer_wrapper');
  if (cartFooter) {
    cartFooter.classList.contains('is-empty') ? cartFooter.parentElement.classList.add('empty_footer') : cartFooter.parentElement.classList.remove('empty_footer')
  }
})


document.addEventListener('DOMContentLoaded', function () {
  const videoThumbnails = document.querySelectorAll('.video_thumbnail');

  videoThumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function () {
      // Find the closest parent container for the video thumbnail (could be any class).
      const parentElement = thumbnail.closest('.video_thumbnail').parentNode;
      console.log(parentElement)
      if (parentElement) {
        // Find the hidden video container inside the same parent element
        const videoContainer = thumbnail.nextElementSibling;
        console.log(videoContainer)
        if (videoContainer) {
          // Find the video element inside the video container
          const videoElement = parentElement.querySelector('video');
          console.log(videoElement)
          if (videoElement) {
            // Show the video container
            videoContainer.style.display = 'block';
            // Hide the thumbnail
            thumbnail.style.display = 'none';
            // Play the video
            videoElement.muted = true; // Mute the video to comply with autoplay policies
            videoElement.play().catch((error) => {
              console.error('Autoplay failed:', error);
            });
          } else {
            console.error('No video element found inside video container.');
          }
        } else {
          console.error('Video container not found.');
        }
      } else {
        console.error('Parent element not found.');
      }
    });
  });
});





const playLinks = document.querySelector('.play_vid');

if (playLinks) {
  playLinks.addEventListener('click', function (event) {
    event.preventDefault(); // Prevent default anchor behavior

    const targetId = playLinks.getAttribute('data-target'); // Get the target ID from data-target attribute
    if (targetId) {
      const videoContainer = document.getElementById(targetId); // Find the video container by ID

      if (videoContainer) {
        videoContainer.style.display = 'block'; // Show the video container
        playLinks.style.display = 'none'; // Hide the play playLinks

        // Hide the thumbnail (assumes thumbnail is within videoContainer or a sibling element)
        const thumbnail = document.querySelector(`[data-thumbnail="${targetId}"]`);
        if (thumbnail) {
          thumbnail.style.display = 'none'; // Hide the thumbnail
        }

        const videoElement = videoContainer.querySelector('video'); // Find the video tag inside
        if (videoElement) {
          videoElement.muted = true; // Mute the video to comply with autoplay policies
          videoElement.play().catch((error) => {
            console.error('Autoplay failed:', error);
          });
        }
      } else {
        console.error('Video container not found for target ID:', targetId);
      }
    } else {
      console.error('data-target attribute is missing or empty on the clicked link.');
    }
  });
}


// Country localization dropdown is managed by <localization-form> component



document.addEventListener('DOMContentLoaded', function () {
  // Listen for clicks on all "Add to Cart" buttons inside modals
  const popupCartBtn = document.querySelectorAll('.popup_product_modal .product-form__buttons .product-form__submit')
  if (popupCartBtn) {
    popupCartBtn.forEach(function (button) {
      button.addEventListener('click', function () {
        // Find the closest modal containing the button
        const modal = button.closest('.modal');
        if (modal) {
          // Close the modal using Bootstrap's modal instance
          const bootstrapModal = bootstrap.Modal.getInstance(modal);
          if (bootstrapModal) {
            bootstrapModal.hide();
          }
        }
      });
    });
  }
});

const ppModal = document.querySelectorAll('.popup_product_modal ');
if (ppModal) {
  ppModal.forEach(function (modal) {
    modal.addEventListener('hidden.bs.modal', function () {
      // Get the ID of the modal
      const modalId = this.getAttribute('id');

      // Find the trigger button that corresponds to this modal
      const triggerButton = document.querySelector(`[data-trigger="${modalId}"]`);
      console.log(triggerButton)

      // Move focus back to the trigger button
      if (triggerButton) {
        triggerButton.focus();
      }
    });
  });
}




document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('.hc_search input');
  const searchButton = document.querySelector('.hc_search button');
  const noResultMsg = document.querySelector('.no_result_msg');

  function searchGuides(query) {
    const allGuideBlocks = document.querySelectorAll('.medi_guide_block, .pdf_guide_block');
    let matchCount = 0;

    if (!query) {
      allGuideBlocks.forEach(function (block) {
        block.style.display = 'block';
      });
      if (noResultMsg) noResultMsg.style.display = 'none';
      return;
    }

    allGuideBlocks.forEach(function (block) {
      const title = block.querySelector('h6') ? block.querySelector('h6').textContent.toLowerCase() : '';
      const description = block.querySelector('.para') ? block.querySelector('.para').textContent.toLowerCase() : '';

      if (title.includes(query) || description.includes(query)) {
        block.style.display = 'block';
        matchCount++;
      } else {
        block.style.display = 'none';
      }
    });

    if (noResultMsg) noResultMsg.style.display = matchCount === 0 ? 'block' : 'none';
  }

  if (searchButton && searchInput) {
    searchButton.addEventListener('click', function () {
      const query = searchInput.value.toLowerCase();
      searchGuides(query);
    });

    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        const query = searchInput.value.toLowerCase();
        searchGuides(query);
      }
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slider_common_container").forEach((nasSlider) => {
    const slider = nasSlider.querySelector(".common_swiper_slider .swiper-wrapper");
    const slides = nasSlider.querySelectorAll(".common_swiper_slider .swiper-slide");
    const leftBtn = nasSlider.querySelector(".scroll_left");
    const rightBtn = nasSlider.querySelector(".scroll_right");
    const customPaginations = nasSlider.querySelector(".custom_paginations");

    if (!slider || slides.length === 0 || !leftBtn || !rightBtn || !customPaginations) return;

    function getSlideWidth() {
      const slide = slides[0];
      const style = window.getComputedStyle(slide);
      const marginRight = parseFloat(style.marginRight) || 0;
      return Math.round(slide.offsetWidth + marginRight);
    }

    function getTotalSteps() {
      const slideWidth = getSlideWidth();
      const totalWidth = slider.scrollWidth;
      const visibleWidth = slider.clientWidth;
      const maxScroll = totalWidth - visibleWidth;
      return Math.round(maxScroll / slideWidth) + 1;
    }

    function updateArrows() {
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const tolerance = 4;
      leftBtn.disabled = slider.scrollLeft <= tolerance;
      rightBtn.disabled = slider.scrollLeft >= (maxScrollLeft - tolerance);
    }

    function createPagination() {
      customPaginations.innerHTML = "";
      const totalSteps = getTotalSteps();

      for (let i = 0; i < totalSteps; i++) {
        const bullet = document.createElement("span");
        bullet.classList.add("swiper-pagination-bullet");
        bullet.setAttribute("role", "button");
        bullet.setAttribute("aria-label", `Go to slide ${i + 1}`);
        bullet.addEventListener("click", () => {
          slider.scrollTo({
            left: i * getSlideWidth(),
            behavior: "smooth"
          });
        });
        customPaginations.appendChild(bullet);
      }
    }

    function updateActiveBullet() {
      const slideWidth = getSlideWidth();
      const bullets = customPaginations.querySelectorAll(".swiper-pagination-bullet");
      const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
      const tolerance = 4;

      let index;
      if (Math.abs(slider.scrollLeft - maxScrollLeft) <= tolerance) {
        index = bullets.length - 1;
      } else {
        index = Math.round(slider.scrollLeft / slideWidth);
      }

      bullets.forEach((b, i) =>
        b.classList.toggle("swiper-pagination-bullet-active", i === index)
      );
    }

    function smoothUpdate() {
      requestAnimationFrame(() => {
        updateArrows();
        updateActiveBullet();
      });
    }

    leftBtn.addEventListener("click", () => {
      slider.scrollBy({ left: -getSlideWidth(), behavior: "smooth" });
      smoothUpdate();
    });

    rightBtn.addEventListener("click", () => {
      slider.scrollBy({ left: getSlideWidth(), behavior: "smooth" });
      smoothUpdate();
    });

    slider.addEventListener("scroll", () => {
      updateArrows();
      updateActiveBullet();
    });

    window.addEventListener("resize", () => {
      createPagination();
      updateArrows();
      updateActiveBullet();
    });

    createPagination();
    updateArrows();
    updateActiveBullet();
  });
});



const contactID = document.querySelector('a[href="#contactFormId"]');
if (contactID) {


  contactID.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1); // Remove the '#' from href
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Check if a child with class 'submitted_successfully' exists
      const hasSubmittedSuccess = targetElement.querySelector('.submitted_successfully') !== null;
      const offset = hasSubmittedSuccess ? 100 : 80;

      const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    }
  });

}

document.addEventListener("DOMContentLoaded", function () {
  const containersSpm = document.querySelectorAll(".spm_media_img");
  if (containersSpm) {
    containersSpm.forEach(container => {
      const img = container.querySelector("img");

      container.addEventListener("mousemove", function (e) {
        const { left, top, width, height } = container.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        img.style.transform = `scale(2.5) translate(${(50 - x) / 1.5}%, ${(50 - y) / 1.5}%)`;
      });

      container.addEventListener("mouseleave", function () {
        img.style.transition = "transform 0.6s ease-in-out"; /* Smooth return */
        img.style.transform = "scale(1)";
      });

      container.addEventListener("mouseenter", function () {
        img.style.transition = "transform 0s ease-out"; /* Smooth zoom-in */
      });
    });
  }

  const containers = document.querySelectorAll('.catalogue_group_container');
  if (containers) {
    containers.forEach((container, index) => {
      container.id = `catlink-${index + 1}`;
    });
  }


  const priorityVariantId = 49775128281392;
  const priorityProductId = 9836986466608;
  const priorityProductHandle = 'priority-shipping';

  function syncPriorityShippingSelect(selectEl) {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Check both cart items (backward compat) and the stored cart attribute
        const inCart = cart.items.some(item => item.product_id === priorityProductId || item.handle === priorityProductHandle);
        const attrYes = cart.attributes && cart.attributes['Priority Shipping'] === 'Yes';
        selectEl.value = (inCart || attrYes) ? 'Yes' : 'No';
      })
      .catch(error => console.error('Priority shipping cart fetch error:', error));
  }

  function attachPriorityShippingListener(selectEl) {
    if (!selectEl || selectEl.dataset.psListenerBound) return;
    selectEl.dataset.psListenerBound = 'true';

    selectEl.addEventListener('change', function () {
      const selectedValue = this.value;

      const doorThicknessInput = document.querySelector('input[name="attributes[Door Thickness]"]');
      const noteInput = document.querySelector('textarea[name="note"]');
      const supportingDocInput = document.querySelector('input[name="attributes[Supporting Document]"]');

      const doorThicknessVal = doorThicknessInput ? doorThicknessInput.value : '';
      const noteVal = noteInput ? noteInput.value : '';
      const supportingDocVal = supportingDocInput ? supportingDocInput.value : '';

      const updateBody = {
        note: noteVal,
        attributes: {
          'Priority Shipping': selectedValue,
          'Door Thickness': doorThicknessVal,
          'Supporting Document': supportingDocVal
        }
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(updateBody)
      })
        .then(() => {
          if (selectedValue === 'Yes') {
            // ── DISABLED: Do not add the $20 Priority Shipping product to the cart. ──
            // To re-enable, uncomment the fetch block below and remove the `return;` line.
            return; // No-op: cart attribute is already updated above; no product is added.
            // return fetch('/cart/add.js', {
            //   method: 'POST',
            //   headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            //   body: JSON.stringify({ id: priorityVariantId, quantity: 1 })
            // });
          } else {
            return fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                const item = cart.items.find(i => i.product_id === priorityProductId || i.handle === priorityProductHandle);
                if (item) {
                  return fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: item.key, quantity: 0 })
                  });
                }
              });
          }
        })
        .then(() => {
          // ── No page reload: the cart attribute is already saved; the dropdown value is set by the user's selection. ──
          // If re-enabling the $20 product add (see disabled block above), you may restore the reload here.
        })
        .catch(error => {
          console.error('Priority shipping update error:', error);
        });
    });
  }

  function initPriorityShipping() {
    const selectEl = document.querySelector('.piorityshipping');
    if (!selectEl) return;

    syncPriorityShippingSelect(selectEl);
    attachPriorityShippingListener(selectEl);
  }

  // Initial setup on page load
  initPriorityShipping();

  // Re-init after every AJAX cart section re-render (quantity/removal replaces the footer DOM)
  document.addEventListener('cart:updated', initPriorityShipping);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      initPriorityShipping();
    });
  }
});

function getUrlParameter(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}
// Check if 'selectedListId' is in the URL query parameters
const selectedhKey = getUrlParameter('hkey');
const selectedListId = getUrlParameter('lid');
// If 'selectedListId' exists in the URL, store it as a cookie (acting like a session)
if (selectedListId) {
  // Set the cookie to store the selectedListId for 1 day (adjust expiration as needed)
  sessionStorage.setItem('selectedListId', selectedListId);
  // alert(sessionStorage.getItem('selectedListId'));
  if (window.location.pathname.includes('swym-share-wishlist')) {
    const newUrl = `${window.Shopify?.routes?.root}pages/swym-product?hkey=${encodeURIComponent(selectedhKey)}&lid=${encodeURIComponent(selectedListId)}&utm_source=swym-Wishlist&utm_medium=shared-wishlist&utm_campaign=${encodeURIComponent(selectedListId)}`;
    // alert(newUrl);
    setTimeout(() => {
      window.location.href = newUrl; // More reliable in Safari
    }, 100);
    ;
  }
}

window.addEventListener("load", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const hasPosted = urlParams.get("customer_posted") === "true";
  const hash = window.location.hash;

  if (hasPosted && hash === "#contact_form") {
    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) {
        const offset = 300; // Adjust to your desired spacing
        const topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: topPos, behavior: "smooth" });
      }
    }, 1000); // Delay long enough to override native jump
  }
});


document.querySelectorAll('.cmn-product-share').forEach(function (el) {
  el.addEventListener('click', function (event) {
    event.preventDefault();

    // const productAvailable = this.getAttribute("data-product-available");
    // if (productAvailable === "true") { // Uncomment if you want to check availability

    let productId = this.getAttribute("data-product-id");
    let getProductUrl = this.getAttribute("data-product-url");
    let productTitle = this.getAttribute("data-product-title");
    let productImage = this.getAttribute("data-product-image");

    let productUrl = `${window.location.origin}${getProductUrl}`;

    document.getElementById("share-facebook").href = `https://www.facebook.com/sharer/sharer.php?u=${productUrl}`;
    document.getElementById("share-twitter").href = `https://twitter.com/intent/tweet?text=${productTitle}&url=${productUrl}`;
    document.getElementById("share-linkedin").href = `https://www.linkedin.com/shareArticle?mini=true&url=${productUrl}&title=${productTitle}`;
    document.getElementById("share-pinterest").href = `https://www.pinterest.com/pin/create/button/?url=${productUrl}&media=${productImage}&description=${productTitle}`;

    document.getElementById("productLink").value = productUrl;

    let modal = new bootstrap.Modal(document.getElementById("acfProductModal"));
    modal.show();

    // }
  });
});

const confirmSubmitBtnEl = document.getElementById("confirmSubmitBtn");
if (confirmSubmitBtnEl) {
  confirmSubmitBtnEl.addEventListener("click", () => {
    const form = window.pendingForm || (typeof pendingForm !== 'undefined' ? pendingForm : null);
    const input = window.pendingInput || (typeof pendingInput !== 'undefined' ? pendingInput : null);
    const selectedValue = window.pendingSelectedValue !== undefined ? window.pendingSelectedValue : (typeof pendingSelectedValue !== 'undefined' ? pendingSelectedValue : null);

    if (form && input && selectedValue !== null) {
      input.value = selectedValue;
      form.submit();
    }

    // Clean up
    window.pendingForm = null;
    window.pendingInput = null;
    window.pendingSelectedValue = null;
    if (typeof pendingForm !== 'undefined') pendingForm = null;
    if (typeof pendingInput !== 'undefined') pendingInput = null;
    if (typeof pendingSelectedValue !== 'undefined') pendingSelectedValue = null;

    // Hide the modal
    const modalEl = document.getElementById("confirmModal");
    if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      const modalInstance = bootstrap.Modal.getInstance(modalEl);
      if (modalInstance) modalInstance.hide();
    }
  });
}




function updateActiveSliderImage(cardBlock, newImageUrl) {
  const imgEl =
    cardBlock.querySelector('.swiper-slide-active img') ||
    cardBlock.querySelector('.is-active img') ||
    cardBlock.querySelector('.active img');

  if (!imgEl) return;

  // Store initial image only once
  if (!imgEl.dataset.initialSrc) {
    imgEl.dataset.initialSrc = imgEl.src;
    imgEl.dataset.initialSrcset = imgEl.srcset || '';
  }

  // If new image exists â†’ use it
  if (newImageUrl) {
    imgEl.src = newImageUrl;
    if (imgEl.srcset !== undefined) {
      imgEl.srcset = newImageUrl;
    }
  }
  // Else â†’ restore initial image
  else {
    imgEl.src = imgEl.dataset.initialSrc;
    if (imgEl.srcset !== undefined) {
      imgEl.srcset = imgEl.dataset.initialSrcset;
    }
  }
}
setTimeout(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  if (tooltipTriggerList) {
    tooltipTriggerList.forEach(el => new bootstrap.Tooltip(el));
  }

  //   const mobFacetCheckBox = document.querySelectorAll('.mobile-facets__item input[type="checkbox"]');

  // if (mobFacetCheckBox.length) {
  //   mobFacetCheckBox.forEach(function (checkbox) {
  //     checkbox.addEventListener('change', function () {
  //       const label = checkbox.parentElement; // .facets__label.facet-checkbox

  //       if (label && label.classList.contains('facet-checkbox')) {
  //         label.classList.toggle('active', checkbox.checked);
  //       }
  //     });
  //   });
  // }

}, 1000);

(function () {
  if (!document.body.classList.contains('template-cart')) return;
  // Helper to parse query string
  function getCartProductsFromURL() {
    const cartWrapper = document.querySelector('.custom_cart_wrapper');
    const params = new URLSearchParams(window.location.search);
    const raw = params.get('cart-products');
    if (!raw) {
      if (cartWrapper) {
        if (cartWrapper.classList.contains('cart-loading')) {
          cartWrapper.classList.remove('cart-loading');
        }
      }
      return [];
    } else {
      if (cartWrapper) {
        cartWrapper.classList.add('cart-loading');
      }
      console.log("item found");
      return raw.split(',').map(item => {
        const [id, qty] = item.split(':');
        return {
          id: parseInt(id, 10),
          quantity: parseInt(qty, 10)
        };
      });
    }
  }

  // Add items to cart via Shopify AJAX API
  async function addItemsToCart(items) {
    if (!items.length) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Cart update failed');

      // Optionally refresh or redirect to cart
      console.log('Items added:', items);
      setTimeout(() => {
        window.location.href = window.Shopify?.routes?.root + 'cart'; // Stay on cart page
      }, 200);

    } catch (error) {
      console.error('Error adding items:', error);
    }
  }

  // Run if the cart-products param exists
  const itemsToAdd = getCartProductsFromURL();
  if (itemsToAdd.length) {
    addItemsToCart(itemsToAdd);
  }
})();

const bottomLink = document.querySelectorAll('a[href]');
const bottomRegex = /#bottom$/;

bottomLink.forEach(link => {
  if (bottomRegex.test(link.getAttribute('href'))) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const allowElement = document.querySelector('#allow-scroll');

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });

    });
  }
});
document.querySelectorAll(".thumb-swiper-prev, .thumb-swiper-next").forEach(function (btn) {
  btn.addEventListener("click", function (e) {
    if (btn.classList.contains("swiper-button-disabled")) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true); // capture phase â€” fires before Swiper or fancybox
});

// For Our Story page
(function () {
  'use strict';

  function bindVideoBlocks(root) {
    const scope = root || document;
    const blocks = scope.querySelectorAll('.apm_video_block:not([data-bound])');

    blocks.forEach((block) => {
      const btn = block.querySelector('.video_play_btn');
      const thumb = block.querySelector('.video_thumbnail');
      const content = block.querySelector('.video_content');

      if (!btn || !thumb || !content) return;

      block.setAttribute('data-bound', 'true');

      btn.addEventListener('click', () => {
        thumb.style.display = 'none';
        content.style.display = 'block';

        const iframe = content.querySelector('iframe');
        const video = content.querySelector('video');

        if (iframe) {
          const src = iframe.getAttribute('data-src');
          if (src) {
            iframe.src = `${src}${src.includes('?') ? '&' : '?'}autoplay=1`;
          }
        } else if (video) {
          video.play().catch(() => { });
        }
      }, { once: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => bindVideoBlocks());
  document.addEventListener('shopify:section:load', (e) => bindVideoBlocks(e.target));
})();

// Common sidebar Slider JS
document.addEventListener('DOMContentLoaded', function () {
  let cswSwipers = [];

  function initCswSwiper() {
    const elements = document.querySelectorAll('.csw_listings_swiper');
    if (!elements.length) return;

    if (window.innerWidth < 992) {
      elements.forEach((el, index) => {
        if (!cswSwipers[index]) {
          const scrollbarEl = el.querySelector('.swiper-scrollbar');
          cswSwipers[index] = new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            scrollbar: scrollbarEl ? {
              el: scrollbarEl,
              draggable: true,
              hide: false,
            } : undefined,
          });
        }
      });
    } else {
      cswSwipers.forEach((instance) => {
        if (instance) instance.destroy(true, true);
      });
      cswSwipers = [];
    }
  }

  initCswSwiper();
  window.addEventListener('resize', () => {
    clearTimeout(window._cswResizeTimer);
    window._cswResizeTimer = setTimeout(initCswSwiper, 150);
  });
});

/* ==========================================================================
   Lazy Loading Engine for Images and Background Images
   ========================================================================== */
(function () {
  function loadMedia(el) {
    if (el.hasAttribute('data-bg')) {
      var bgUrl = el.getAttribute('data-bg');
      if (bgUrl) {
        el.style.backgroundImage = "url('" + bgUrl + "')";
        el.classList.add('lazy-bg-loaded');
        el.removeAttribute('data-bg');
      }
    }
    if (el.hasAttribute('data-src')) {
      var srcUrl = el.getAttribute('data-src');
      var srcSetUrl = el.getAttribute('data-srcset');
      if (srcUrl) {
        if (srcSetUrl) el.srcset = srcSetUrl;
        el.src = srcUrl;
        el.classList.add('lazy-loaded');
        el.removeAttribute('data-src');
        if (srcSetUrl) el.removeAttribute('data-srcset');
      }
    }
  }

  function initLazyMediaObserver() {
    var lazyElements = document.querySelectorAll('[data-bg], img[data-src]');
    if (!lazyElements.length) return;

    if ('IntersectionObserver' in window) {
      var mediaObserver = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              loadMedia(entry.target);
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '300px 0px 300px 0px' }
      );

      lazyElements.forEach(function (el) {
        if (!el.hasAttribute('data-media-observing')) {
          el.setAttribute('data-media-observing', 'true');
          mediaObserver.observe(el);
        }
      });

      if (!window._lazyMediaMutationObserver) {
        window._lazyMediaMutationObserver = new MutationObserver(function (mutations) {
          var addedNodesExist = false;
          mutations.forEach(function (m) {
            if (m.addedNodes && m.addedNodes.length) addedNodesExist = true;
          });
          if (addedNodesExist) {
            document.querySelectorAll('[data-bg]:not([data-media-observing]), img[data-src]:not([data-media-observing])').forEach(function (el) {
              el.setAttribute('data-media-observing', 'true');
              mediaObserver.observe(el);
            });
          }
        });
        window._lazyMediaMutationObserver.observe(document.body, { childList: true, subtree: true });
      }
    } else {
      lazyElements.forEach(function (el) {
        loadMedia(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyMediaObserver);
  } else {
    initLazyMediaObserver();
  }

  document.addEventListener('shopify:section:load', initLazyMediaObserver);
})();